import { render, staticRenderFns } from "./Base_Type4.vue?vue&type=template&id=acfe0cc6&scoped=true"
import script from "./Base_Type4.vue?vue&type=script&lang=js"
export * from "./Base_Type4.vue?vue&type=script&lang=js"
import style0 from "./Base_Type4.vue?vue&type=style&index=0&id=acfe0cc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfe0cc6",
  null
  
)

export default component.exports